import React, { useState, useEffect } from 'react';
import {
  format,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  add,
  isToday,
  isSameMonth,
  startOfDay,
} from 'date-fns';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  CalendarIcon,
  MapPinIcon,
  EllipsisHorizontalIcon,
  FlagIcon,
  XCircleIcon,
} from '@heroicons/react/20/solid';
import StaffNav from './managernav';
import { useNavigate } from 'react-router-dom';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Shifts() {

    const Navigate = useNavigate();
    
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [shifts, setShifts] = useState([]);
    const [updated, setUpdated] = useState(null);

  // Generate the days of the calendar dynamically

  const currentDate = new Date();
  
  const startDate = startOfWeek(startOfMonth(currentDate), { weekStartsOn: 1 });
  const endDate = endOfWeek(endOfMonth(currentDate), { weekStartsOn: 1 });

  const days = [];
  let day = startOfDay(startDate); // Normalize the start day to midnight

  // Populate the days array with all days of the current month
  while (day <= endDate) {
    days.push(day);
    day = add(day, { days: 1 }); // Move to the next day
  }

  const token = localStorage.getItem('token');

  // Fetch shifts data for a selected day
  const fetchShifts = async (date) => {
    console.log('Date being sent to API:', date);
    try {
      const formattedDate = format(date, 'yyyy-MM-dd');
      console.log('Formatted Date:', formattedDate);
  
      const response = await fetch(`https://api.insightos.co.uk/api/shiftsday/${formattedDate}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json',
         },
         credentials: 'include',

      });
  
      console.log('Raw API Response:', response);
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      console.log('Parsed Data:', data);
  
      setShifts(data.data); // Ensure this updates your state
      setUpdated(null);
    } catch (error) {
      console.error('Error fetching shifts:', error);
    }
  };
  

  // Navigate to previous or next month
  const previousMonth = () => setCurrentMonth(add(currentMonth, { months: -1 }));
  const nextMonth = () => setCurrentMonth(add(currentMonth, { months: 1 }));

    // Handle the Sick button click

    const handleSick = async (id) => {

        console.log(id);

        try {
            const response = await fetch(`https://api.insightos.co.uk/api/sick/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
            });


            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            console.log(data);
            setUpdated("Updated Staff Status");
            fetchShifts(selectedDate);
        }
        catch (error) {
            console.error(error);
        }

    };

    // Handle the Delete button click

    const handleDelete = async (id) => {
            
            try {
                const response = await fetch(`https://api.insightos.co.uk/api/deleteshift/${id}`, {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                });
    
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
    
                const data = await response.json();
                console.log(data);
                fetchShifts(selectedDate);
                setUpdated("Shift Deleted");
            }
            catch (error) {
                console.error(error);
            }
    
        }


  return (
    <div>
      <StaffNav />
      <h2 className="text-base font-semibold text-gray-900">Shift Schedule</h2>
      <button onClick={() => Navigate('/meetingscalendar')}
            type="button"
            className="mt-8 w-1/3 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Meetings Schedule
          </button>
          {updated && <div className="text-green-600">{updated}</div>}
      <div className="lg:grid lg:grid-cols-12 lg:gap-x-16">
        {/* Calendar Section */}
        <div className="mt-10 text-center lg:col-start-8 lg:col-end-13 lg:row-start-1 lg:mt-9 xl:col-start-9">
          <div className="flex items-center text-gray-900">
            <button
              type="button"
              onClick={previousMonth}
              className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Previous month</span>
              <ChevronLeftIcon className="size-5" aria-hidden="true" />
            </button>
            <div className="flex-auto text-sm font-semibold">{format(currentMonth, 'MMMM yyyy')}</div>
            <button
              type="button"
              onClick={nextMonth}
              className="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">Next month</span>
              <ChevronRightIcon className="size-5" aria-hidden="true" />
            </button>
          </div>

          <div className="mt-6 grid grid-cols-7 text-xs/6 text-gray-500">
            <div>M</div>
            <div>T</div>
            <div>W</div>
            <div>T</div>
            <div>F</div>
            <div>S</div>
            <div>S</div>
          </div>

          <div className="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200">
            {days.map((day, dayIdx) => (
              <button
                key={day.toISOString()}
                onClick={() => {
                  setSelectedDate(day);
                  fetchShifts(day);
                }}
                type="button"
                className={classNames(
                  'py-1.5 hover:bg-green-500 focus:z-10',
                  isSameMonth(day, currentMonth) ? 'bg-white' : 'bg-gray-50',
                  isToday(day) && 'text-indigo-600 font-bold',
                  selectedDate && day.toDateString() === selectedDate.toDateString() && 'bg-indigo-600 text-blue-700',
                  dayIdx === 0 && 'rounded-tl-lg',
                  dayIdx === 6 && 'rounded-tr-lg',
                  dayIdx === days.length - 7 && 'rounded-bl-lg',
                  dayIdx === days.length - 1 && 'rounded-br-lg'
                )}
              >
                <time dateTime={day.toISOString()} className="mx-auto flex size-7 items-center justify-center rounded-full">
                  {format(day, 'd')}
                </time>
              </button>
            ))}
          </div>

          
        </div>

        {/* Shifts Section */}
        <ol className="mt-4 divide-y divide-gray-100 text-sm/6 lg:col-span-7 xl:col-span-8">
          {shifts.length > 0 ? (
            shifts.map((shift, idx) => (
              <li key={idx} className="relative flex divide-y divide-gray-100 mt-5 space-x-6 py-6 xl:static">
                <div className="flex-auto">
                  <h3 className="pr-10 font-semibold text-blue-700 xl:pr-0">{shift.Name}</h3>
                  <dl className="mt-2 flex flex-col text-gray-500 xl:flex-row">
                    <div className="flex items-start space-x-3">
                      <dt className="mt-0.5">
                        <span className="sr-only">Shift</span>
                        <CalendarIcon className="size-5 text-blue-700" aria-hidden="true" />
                      </dt>
                      <dd className="text-blue-700">
                        {shift.StartTime} - {shift.EndTime}
                      </dd>
                    </div>

                    <div className="mt-2 flex items-start space-x-3 xl:ml-3.5 xl:mt-0 xl:border-l xl:border-gray-400/50 xl:pl-3.5">
                      <dt className="mt-0.5">
                        <span className="sr-only">Status</span>
                        <MapPinIcon className="size-5 text-orange-600" aria-hidden="true" />
                      </dt>
                      <dd>
                        {shift.Sick ? 'Sick' : shift.Holiday ? 'Holiday' : shift.Late ? 'Late' : 'On Time'}
                      </dd>
                    </div>
                  </dl>

                  <div className="mt-2 flex">
                    <button onClick={() => handleSick(shift.id)}
                      data-component="calendar-shift-actions"
                      data-time-saved="3"
                      data-feature="mark_sick_put"
                      type="button"
                      className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Sick
                      <FlagIcon aria-hidden="true" className="-mr-0.5 size-5" />
                    </button>
                    <button onClick={() => handleDelete(shift.id)}
                      type="button"
                      className="inline-flex items-center gap-x-1.5 ml-5 rounded-md bg-red-700 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Cancel Shift
                      <XCircleIcon aria-hidden="true" className="-mr-0.5 size-5" />
                    </button>
                  </div>
                </div>

                <div className="absolute right-0 top-6 xl:static xl:ml-3">
                  <EllipsisHorizontalIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
              </li>
            ))
          ) : (
            <div>No shifts for this day.</div>
          )}
        </ol>
      </div>
    </div>
  );
}
